import React, { useState, useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import PersonIcon from '@mui/icons-material/Person';
import Avatar from 'react-avatar-edit';
 import "./AvatarUser.css";
const AvatarUser = () => {
  const fileInputRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [preview, setPreview] = useState(null);
 
  const handleCrop = (croppedImage) => {
    setPreview(croppedImage);
  };
  
  const handleAvatarClick = () => {
    if (selectedImage) {
      setModalIsOpen(true);
    } else {
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    }
  };
  const handleFileInputChange = (e) => {
    const selectedFile = e.target.files?.[0];
    if (selectedFile) {
      const imageUrl = URL.createObjectURL(selectedFile);
      setSelectedImage(imageUrl);
      setModalIsOpen(true);
    }
  };
  
  const handleMouseEnter = () => {
    setIsHovered(true);
  };
 
  const handleMouseLeave = () => {
    setIsHovered(false);
  };
 
  const closeModal = () => {
    setModalIsOpen(false);
  };
 
  const handleSave = () => {
    if (preview) {
      setSelectedImage(preview);
    }
    closeModal();
  };
  return (
    <>
      <div
        className={` ${isHovered ? 'hovered' : ''}`}
        onClick={handleAvatarClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="avatar-user">
          {selectedImage ? (
            <img src={selectedImage} alt="User Avatar" />
          ) : isHovered ? (
            <CameraAltIcon
                style={{ fontSize: "40px", marginLeft: "4px" }}
              />
          ) : (
             <PersonIcon
                style={{ fontSize: "40px", marginLeft: "4px" }}
              />
          )}
        </div>
        <input
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          ref={fileInputRef}
          onChange={handleFileInputChange}
        />
      </div>
      <Modal
        show={modalIsOpen}
        onHide={closeModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h1>Use Profile Photo</h1>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='user-photo-modal'>
          {selectedImage && (
            <div className="avatar-editor-container">
              <Avatar
                width={390}
                height={295}
                onCrop={handleCrop}
                src={selectedImage}
              />
            </div>
          )}
          <div className='user-photo-modal-btns'>
            <Button
              variant="success"
              onClick={handleSave}
            >Appliquer</Button>
             
            <Button
              variant="secondary"
              onClick={closeModal}
              >Annuler</Button>

          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
 
export default AvatarUser;
 